import type { FormConfig } from '@/utils/form';
import {
  anredeId,
  beruf,
  berufsstatus,
  bezugZumVnJuristischePerson,
  familienstand,
  fuehrerscheindatum,
  geburtsdatum,
  hasAnBegleitetenFahrenTeilgenommen,
  hasAnSicherheitstrainingTeilgenommen,
  hasFuehrerscheinInEUErworben,
  hasJahreskarteOeffentlicherPersonenverkehr,
  hasMinderjaehrigeKinder,
  hasMinderjaehrigeKinderAlterAeltestesKind,
  hasMinderjaehrigeKinderAlterJuengstesKind,
  hasPunkteInFlensburg,
  hasWohneigentum,
  hasWohnsitzMin5JahreInBrd,
  isHauptnutzer,
  isMitarbeiterAutohersteller,
  isVorsteuerAbzugsberechtigt,
  jahreskarteOeffentlicherPersonenverkehrBahnComfort,
  jahreskarteOeffentlicherPersonenverkehrBahnNormal,
  jahreskarteOeffentlicherPersonenverkehrSonstige,
  minderjaehrigeKinderAlter,
  nationalitaet,
  speziellerArbeitgeber,
  tarifgruppe,
  vnIsFullAge,
  wohneigentumGesellschaftID,
  wohneigentumIsVermietet,
  wohneigentumTyp,
} from '@/features/Sparten/shared/fieldConfigs/kfz/input/fahrerkreisFieldConfig';

export const fahrerkreisCompanyNutzerSection: FormConfig = {
  formName: 'KfzFahrerkreisCompanyNutzer',
  fieldConfigs: [
    bezugZumVnJuristischePerson,
    anredeId,
    geburtsdatum,
    familienstand,
    nationalitaet,
    berufsstatus,
    beruf,
    speziellerArbeitgeber,
    tarifgruppe,
    fuehrerscheindatum,
    vnIsFullAge,
    hasMinderjaehrigeKinder,
    minderjaehrigeKinderAlter,
    hasMinderjaehrigeKinderAlterJuengstesKind,
    hasMinderjaehrigeKinderAlterAeltestesKind,
    hasFuehrerscheinInEUErworben,
    hasAnBegleitetenFahrenTeilgenommen,
    hasAnSicherheitstrainingTeilgenommen,
    hasPunkteInFlensburg,
    isMitarbeiterAutohersteller,
    isVorsteuerAbzugsberechtigt,
    isHauptnutzer,
    hasWohnsitzMin5JahreInBrd,
    hasJahreskarteOeffentlicherPersonenverkehr,
    jahreskarteOeffentlicherPersonenverkehrBahnNormal,
    jahreskarteOeffentlicherPersonenverkehrBahnComfort,
    jahreskarteOeffentlicherPersonenverkehrSonstige,
    hasWohneigentum,
    wohneigentumTyp,
    wohneigentumGesellschaftID,
    wohneigentumIsVermietet,
  ],
};
